import { BrandGroupEntity } from '@/entities/brand-group.entity';
import { ProductGroupEntity } from '@/entities/product-group.entity';
import { ReviewEntity } from '@/entities/review.entity';
import { useReviewsPageFetchTransport } from '@/context/use-reviews-page-fetch-transport';
import { useReviewsPagePaginationTransport } from '@/context/use-reviews-page-pagination-transport';
import { Sort } from '@/types/sort.type';

type UseReviewsPageTransportArgs = {
    clientId: string;
    accessToken: string;
    reviewsOnPage: number;
    filtersQuery: string[];
    sort: Sort;
    setProductsState: (value: ProductGroupEntity[]) => void;
    setBrandGroupsState: (value: BrandGroupEntity[]) => void;
    setReviewsAndTotalState: (reviews: ReviewEntity[], total: number) => void;
    setReviewsOnPageState: (value: number) => void;
};

type ReviewsPageTransport = {
    getProducts: (abort?: AbortSignal) => Promise<void>;
    getBrandGroups: (abort?: AbortSignal) => Promise<void>;
    refetchReviews: (abort?: AbortSignal) => Promise<void>;
    refetchReviewsAndProducts: (abort?: AbortSignal) => Promise<void>;
    setReviewsOnPage: (count: number) => Promise<void>;
    isReviewsRefetchRunning: boolean;
};

export const useReviewsPageTransport = ({
    clientId,
    accessToken,
    reviewsOnPage,
    filtersQuery,
    sort,
    setProductsState,
    setBrandGroupsState,
    setReviewsAndTotalState,
    setReviewsOnPageState,
}: UseReviewsPageTransportArgs): ReviewsPageTransport => {
    const { getProducts, getBrandGroups, refetchReviews, refetchReviewsAndProducts, isReviewsRefetchRunning } =
        useReviewsPageFetchTransport({
            clientId,
            accessToken,
            reviewsOnPage,
            filtersQuery,
            sort,
            setProductsState,
            setBrandGroupsState,
            setReviewsAndTotalState,
        });
    const { setReviewsOnPage } = useReviewsPagePaginationTransport({
        setReviewsOnPageState,
    });

    return {
        getProducts,
        getBrandGroups,
        refetchReviews,
        refetchReviewsAndProducts,
        setReviewsOnPage,
        isReviewsRefetchRunning,
    };
};
